var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-page"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 12.5H12M15 12.5H12M12 12.5V9.5M12 12.5V15.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4 21.9V3.1C4 2.76863 4.26863 2.5 4.6 2.5H16.2515C16.4106 2.5 16.5632 2.56321 16.6757 2.67574L19.8243 5.82426C19.9368 5.93679 20 6.0894 20 6.24853V21.9C20 22.2314 19.7314 22.5 19.4 22.5H4.6C4.26863 22.5 4 22.2314 4 21.9Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 2.5V5.9C16 6.23137 16.2686 6.5 16.6 6.5H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPage);
export default __webpack_public_path__ + "static/media/add-page.8e43aed53af78b9d79fe76eeda47673b.svg";
export { ForwardRef as ReactComponent };